<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-school
            </v-icon>
            <span class="title">Data Jurusan</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              Jurusan
              <v-icon large>mdi-school</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="12">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          v-if="!loading.getdata"
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editData(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formadddata"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="8" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="adddata.nama_jur"
                                :rules="[rules.required]"
                                label="Nama Jurusan"
                                name="nama"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <alertsp :alertdata="alertdata"></alertsp>
                              <v-btn
                                large
                                block
                                :loading="loading.adddata"
                                :disabled="loading.adddata || !formadd.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.data"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      v-if="dmodaldata.data">
      <v-card>
        <v-toolbar :color="maincolor" dark class="px-md-5" flat>
          <v-toolbar-title>
            Update data jurusan
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dmodal.data = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="11">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitUpdate"
                    ref="formupdatedata"
                    v-model="formupdate.valid"
                    lazy-validation>
                    <v-row justify="center">
                      <v-col cols="12" md="8">
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              v-model="dmodaldata.data.nama_jur"
                              :rules="[rules.required]"
                              label="Nama jurusan"
                              name="nama"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="dmodaldata.data.slug_jur"
                              :rules="[rules.required]"
                              label="Slug page"
                              name="slug"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="dmodaldata.data.web_jur"
                              :rules="[rules.required]"
                              label="Website"
                              name="website"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              name="prev"
                              label="Preview info (Max 300 Karakter)"
                              placeholder="Tuliskan preview info disini..."
                              counter
                              rows="3"
                              v-model="dmodaldata.data.desc_jur"
                              :rules="[rules.required, rules.textlimit]">
                            </v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <vue-editor
                              v-model="dmodaldata.data.content_jur"
                              placeholder="Tuliskan isi info disini..."
                              :rules="[rules.required]">
                            </vue-editor>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-select
                              :items="liststatus"
                              name="statusjurusan"
                              v-model="dmodaldata.data.status_jur"
                              label="Status">
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12">
                            <v-img
                              v-if="dmodaldata.data.img_jur"
                              :lazy-src="require('../../assets/default.jpg')"
                              :src="api + '/upload/jurusan/' + dmodaldata.data.img_jur"
                              contain>
                            </v-img>
                            <v-img
                              v-if="!dmodaldata.data.img_jur"
                              :lazy-src="require('../../assets/default.jpg')"
                              :src="require('../../assets/default.jpg')"
                              contain>
                            </v-img>
                          </v-col>
                          <v-col cols="12">
                            <v-file-input
                              v-model="dmodaldata.data.img_jurnew"
                              :rules="rules.files"
                              accept=".png, .jpg, .jpeg"
                              name="fileresume"
                              placeholder="Select file"
                              label="Image Thumbnail (max. 500 Kb)"
                              show-size
                              prepend-icon="mdi-camera">
                            </v-file-input>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" class="text-center">
                            <alertsp :alertdata="alertupdate"></alertsp>
                            <v-btn
                              block
                              large
                              :loading="loading.updatedata"
                              :disabled="loading.updatedata || !formupdate.valid"
                              :color="maincolor"
                              dark
                              type="submit">
                              Simpan
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'JurusanAdmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      adddata: false,
      updatedata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_jur' },
      { text: 'Status', value: 'status_jur' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    adddata: {
      nama_jur: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 8 || 'Min 8 characters',
      nik: (v) => v.length >= 16 || 'Min 16 characters',
      textlimit: (v) => (v) && v.length <= 300 || 'Max 300 characters',
      files: [
        (value) => !value || value.size < 500000 || 'File kurang dari 500 Kb!',
      ],
    },
    tabdata: null,
    dmodal: {
      data: false,
    },
    dmodaldata: {
      data: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getData();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getData() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jurusan/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formadddata.validate()) {
        if (this.tokenscr) {
          this.loading.adddata = true;
          this.axios
            .post(
              this.api + '/api/jurusan/',
              qs.stringify(
                this.adddata,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formadddata.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Jurusan "' + resdata.data + '" berhasil ditambahkan!';
                  this.getData();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.adddata = false;
            })
            .catch((error) => {
              this.loading.adddata = false;
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    editData(item) {
      this.alertupdate.show = false;
      this.dmodal.data = true;
      this.dmodaldata.data = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatedata.validate()) {
        if (this.tokenscr) {
          this.loading.updatedata = true;
          const dataadd = this.dmodaldata.data;
          const formData = new FormData();
          formData.append('nama_jur', dataadd.nama_jur);
          formData.append('slug_jur', dataadd.slug_jur);
          formData.append('web_jur', dataadd.web_jur);
          formData.append('desc_jur', dataadd.desc_jur);
          formData.append('content_jur', dataadd.content_jur);
          formData.append('img_jur', dataadd.img_jur);
          formData.append('status_jur', dataadd.status_jur);
          formData.append('id_jur', dataadd.id_jur);
          formData.append('img_jurnew', dataadd.img_jurnew);
          this.axios
            .post(
              this.api + '/api/jurusan/update',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.data.nama_jur + '" berhasil diubah!';
                  this.getData();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.updatedata = false;
            })
            .catch((error) => {
              this.loading.updatedata = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
